import { injectable } from "tsyringe";
import { PusatResolusiV2ApiRepository } from "@/app/infrastructures/repositories/api/PusatResolusiV2ApiRepository";
import { CheckTicketPusatResolusiRequest, FinishIssuePusatResolusiV2Request, ListTicketPusatResolusiRequest, SendChatPusatResolusiRequest, SubmitNotePusatResolusiRequest, GetConversationRequest, ListSTTPusatResolusi, TicketCounterPusatResolusiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import {
  CategoryPusatResolusi,
  TicketCounterPusatResolusi,
  CheckIssuePusatResolusi,
  TicketPusatResolusiDetail,
  PusatResolusiSTTData
} from "@/domain/entities/PusatResolusiV2";

@injectable()
export class PusatResolusiV2Presenter {
  private repository: PusatResolusiV2ApiRepository;

  constructor(repository: PusatResolusiV2ApiRepository) {
    this.repository = repository;
  }

  checkTicket(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail> {
    return this.repository.checkTicket(params);
  }

  getListCategory(
    params: CheckTicketPusatResolusiRequest
  ): Promise<CategoryPusatResolusi[]> {
    return this.repository.getListCategory(params);
  }

  getTicketCounter(params: TicketCounterPusatResolusiRequest): Promise<TicketCounterPusatResolusi> {
    return this.repository.getTicketCounter(params);
  }

  getListTicket(
    params: ListTicketPusatResolusiRequest
  ) {
    return this.repository.getListTicket(params);
  }

  getSTTList(params: ListSTTPusatResolusi): Promise<PusatResolusiSTTData> {
    return this.repository.getSTTList(params);
  }


  checkIssue(
    params: CheckTicketPusatResolusiRequest
  ): Promise<CheckIssuePusatResolusi> {
    return this.repository.checkIssue(params);
  }

  followTicket(id: number) {
    return this.repository.followTicket(id);
  }

  finishIssue(id: number, payload: FinishIssuePusatResolusiV2Request) {
    return this.repository.finishIssue(id, payload);
  }
  getTicketDetail(id: number) {
    return this.repository.getTicketDetail(id);
  }

  getTicketAction(id: number) {
    return this.repository.getTicketAction(id);
  }

  submitNote(payload: SubmitNotePusatResolusiRequest): Promise<boolean> {
    return this.repository.submitNote(payload);
  }

  create(
    payload: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail> {
    return this.repository.create(payload);
  }

  getMentionData(id: number) {
    return this.repository.getMention(id);
  }

  sendChat(id: number, payload: SendChatPusatResolusiRequest) {
    return this.repository.sendChat(id, payload);
  }

  getConversation(id: number, params: GetConversationRequest) {
    return this.repository.getConversation(id, params);
  }

  connectConversationWebsocket(id: number): WebSocket {
    return this.repository.connectConversationWebsocket(id);
  }
}
